import { ErrorTypes } from '~domain/error/error-types';

const DEFAULT_MESSAGE = 'An unknown error occurred while performing client request';

/**
 * Represents any `ApiSauce` error.
 */
export class ClientError extends Error {
  public type: string;

  constructor(message: string = DEFAULT_MESSAGE) {
    super(message);

    this.type = ErrorTypes.CLIENT_ERROR;
  }
}

export interface ClientErrorWithStatus extends ClientError {
  statusCode: number;
}
